var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 15h10.4a.5.5 0 1 1 0 1H.5a.5.5 0 1 1 0-1zM2.96 4.8H6v3.8H2.2V5.56c0-.42.34-.76.76-.76zM2.2 10H6v3.8H2.808a.608.608 0 0 1-.608-.608V10zM15.065 0c.516 0 .935.419.935.935V8.6H7.4V0h7.665zm-1.276 1.743H9.143v5.114h5.114V2.21a.468.468 0 0 0-.468-.468zM7.4 10h3.8v3.192a.608.608 0 0 1-.608.608H7.4V10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakdown);
export default __webpack_public_path__ + "static/media/breakdown.199f2fd2cc7d887c4813376f3609cf4f.svg";
export { ForwardRef as ReactComponent };